import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { useHistory, useLocation } from 'react-router-dom';
import './MachineList.css';
import MachineCatalog from './MachineCatalog';

const MachineList: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  const muscleParam = new URLSearchParams(location.search).get('muscle') || '';
  const hasActiveSession = Boolean(localStorage.getItem('sessionId'));

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/my/advisor" text="" />
          </IonButtons>
          <IonTitle>Machines</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen className="machine-list-content">
        <section className="machine-list-intro">
          <div className="machine-list-intro__copy">
            <span>Exercise library</span>
            <h1>Find your machine</h1>
            <p>Search by equipment, category or the muscle you want to train.</p>
          </div>
          <img
            src="/assets/ploppy/ploppy-advisor-idea.png"
            alt="Ploppy has a training idea"
          />
        </section>

        <MachineCatalog
          initialMuscle={muscleParam}
          onAddMachine={
            hasActiveSession
              ? machine =>
                  history.push(`/my/trainingstart?addMachine=${machine.id}`)
              : undefined
          }
        />
      </IonContent>
    </IonPage>
  );
};

export default MachineList;
